import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { PeremrillojiParametri, PeremriVeta, PeremriNumri, PeremriRasa, PeremriTrajta } from '@core/enums/peremri/peremri.enum';

@Injectable({
  providedIn: 'root'
})
export class PeremriIPacaktuarFormulaService {

  constructor(private fb: UntypedFormBuilder) { }

  generateFormula(peremriLlojiParametri: PeremrillojiParametri, formArray: UntypedFormArray) {
    if (!peremriLlojiParametri) {
      throw new Error('Lloji i përemrit është i zbrazët');
    }

    const ctrls = this.getFormulaControls(peremriLlojiParametri)

    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    ctrls.forEach((f) => {
      this.setFormula(formArray, f.trajtaId, f.numriId, f.rasaId, f.pershkrimi);
    })
  }


  getFormulaControls(
    peremriLlojiParametri: PeremrillojiParametri
  )
    : { trajtaId: number, numriId: number, rasaId: number, pershkrimi?: string }[] {
    const ctrls: any[] = [];
    switch (peremriLlojiParametri) {
      case PeremrillojiParametri.Mashkullore: {
        ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Emerore, pershkrimi: 'tjetër', }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'tjetri' }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'tjetri', }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'tjetër' }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'tjetri' })

        ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Emerore, pershkrimi: 'tjerë', }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'tjerëve' }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'tjerëve', }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'tjerë' }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'tjerëve' })


        ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Emerore, pershkrimi: 'tjetri', }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'tjetrit' }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'tjetrit', }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'tjetrin' }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'tjetrit' })

        ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Emerore, pershkrimi: 'tjerët', }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'tjerëve' }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'tjerëve', }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'tjerët' }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'tjerëve' })
        break;
      }

      case PeremrillojiParametri.Femeerore: {
        ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Emerore, pershkrimi: 'tjetër', }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'tjetre' }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'tjetre', }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'tjetër' }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'tjetre' })

        ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Emerore, pershkrimi: 'tjera', }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'tjerave' }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'tjerave', }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'tjera' }),
          ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'tjerave' })


        ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Emerore, pershkrimi: 'tjetra', }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'tjetrës' }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'tjetrës', }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'tjetrën' }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'tjetrës' })

        ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Emerore, pershkrimi: 'tjerat', }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'tjerave' }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'tjerave', }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'tjerat' }),
          ctrls.push({ trajtaId: PeremriTrajta.Eshquar, numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'tjerave' })
        break;
      }

      case PeremrillojiParametri.Asnjanees: {
        ctrls.push({ trajtaId: PeremriTrajta.Epashquar, numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Emerore, pershkrimi: 'tjetër', })
        break;
      }

      case PeremrillojiParametri.Rasee: {
        ctrls.push({ rasaId: PeremriRasa.Emerore, pershkrimi: 'kushdo', }),
          ctrls.push({ rasaId: PeremriRasa.Gjinore, pershkrimi: 'kujtdo' }),
          ctrls.push({ rasaId: PeremriRasa.Dhanore, pershkrimi: 'kujtdo', }),
          ctrls.push({ rasaId: PeremriRasa.Kallezore, pershkrimi: 'këdo' }),
          ctrls.push({ rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'kujtdo' })
        break;
      }

      case PeremrillojiParametri.RaseeMashkullore: {
        ctrls.push({ rasaId: PeremriRasa.Emerore, pershkrimi: 'njëri', }),
          ctrls.push({ rasaId: PeremriRasa.Gjinore, pershkrimi: 'njërit' }),
          ctrls.push({ rasaId: PeremriRasa.Dhanore, pershkrimi: 'njërit', }),
          ctrls.push({ rasaId: PeremriRasa.Kallezore, pershkrimi: 'njërin' }),
          ctrls.push({ rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'njërit' })
        break;
      }

      case PeremrillojiParametri.RaseeFemeerore: {
        ctrls.push({ rasaId: PeremriRasa.Emerore, pershkrimi: 'njëra', }),
          ctrls.push({ rasaId: PeremriRasa.Gjinore, pershkrimi: 'njërës' }),
          ctrls.push({ rasaId: PeremriRasa.Dhanore, pershkrimi: 'njërës', }),
          ctrls.push({ rasaId: PeremriRasa.Kallezore, pershkrimi: 'njërën' }),
          ctrls.push({ rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'njërës' })
        break;
      }

      case PeremrillojiParametri.PaVeccori: {

        break;
      }

    }
    return ctrls;
  }

  private setFormula(formArray: UntypedFormArray, trajta: PeremriTrajta, numri: PeremriNumri, rasa: PeremriRasa, value?: string) {
    let fg = formArray.controls.find(
      (c) => c.get('trajtaId')?.value == trajta && c.get('numriId')?.value == numri && c.get('rasaId')?.value == rasa
    ) as UntypedFormGroup;
    if (fg) fg.get('pershkrimi')?.setValue(value);
    else {
      let fg = this.fb.group({
        trajtaId: trajta,
        numriId: numri,
        rasaId: rasa,
        pershkrimi: value,
      });
      if (formArray.disabled) fg.disable();
      formArray.push(fg);
    }
  }
}
